import type { ChecklistOption } from './checklistHelper'

const PART_SEPARATOR = ' · '
const REFUNDABLE_SUFFIX = ' refundable'
const PAYMENT_METHOD_PARAM_KEY = 'payment_method'
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
const DATE_TIME_PATTERN = /^(\d{2}\.\d{2}\.\d{4})(?: (\d{2}:\d{2}))?$/

export type ChecklistOptionDetails = {
  kind: string
  paymentMethod?: string
  title: Array<string>
  refundable?: string
  details: Array<string>
  date?: string
  time?: string
  uuid?: string
}

const splitParts = (text?: string) =>
  (text ?? '')
    .split(PART_SEPARATOR)
    .map((part) => part.trim())
    .filter(Boolean)

const isMetaPart = (part: string) => UUID_PATTERN.test(part) || DATE_TIME_PATTERN.test(part)

// "Refund · Paymaxis · $10.0 refundable" + "13.10.2025 13:22 · Card VISA ••3376 · <uuid>"
// => { kind: 'Refund', title: ['Paymaxis'], refundable: '$10.0', details: ['Card VISA ••3376'], date, time, uuid }
export const parseChecklistOption = (option: ChecklistOption): ChecklistOptionDetails => {
  const [kind = '', ...titleParts] = splitParts(option.name)
  const descriptionParts = splitParts(option.description)
  const refundablePart = titleParts.find((part) => part.endsWith(REFUNDABLE_SUFFIX))
  const [, date, time] = descriptionParts.map((part) => DATE_TIME_PATTERN.exec(part)).find(Boolean) ?? []
  const paymentMethod = option.fields.find((f) => f.param_key === PAYMENT_METHOD_PARAM_KEY)?.value

  return {
    kind,
    paymentMethod: paymentMethod === undefined ? undefined : String(paymentMethod),
    title: titleParts.filter((part) => part !== refundablePart),
    refundable: refundablePart?.slice(0, -REFUNDABLE_SUFFIX.length),
    details: descriptionParts.filter((part) => !isMetaPart(part)),
    date,
    time,
    uuid: descriptionParts.find((part) => UUID_PATTERN.test(part)),
  }
}
